import { Swiper, Lazy } from 'swiper';
Swiper.use( [ Lazy ] );

export default class Brands {
	constructor( module ) {
		this.module = module;
		this.container = module.querySelector( '.min-height' );
		this.brands = module.querySelectorAll( '.brand' );
		this.descriptions = module.querySelectorAll( '.brand-description' );
		this.footnotes = module.parentNode.querySelectorAll(
			'.brand-footnotes .footnotes'
		);
		this.headerMenu = document.querySelector( '.header .menu' );
		this.headerMenuItems = document.querySelectorAll(
			'.header .menu .menu-item a'
		);
		this.underHeader = document.querySelector( '.under-header' );
		this.underFooter = document.querySelector( '.under-footer' );
		this.timeline = document.querySelector( '.timeline' );

		this.brands.forEach( ( currentValue, currentIndex ) => {
			currentValue.addEventListener( 'click', ( event ) =>
				this.updateBrands( event, currentIndex )
			);
		} );
	}

	updateBrands( event, index ) {
		if ( event.target.dataset.color !== '#fff' ) {
			document.body.classList.add( 'bg-color' );
		} else {
			document.body.classList.remove( 'bg-color' );
		}

		this.container.classList.add( 'active' );

		document.body.style.background = event.target.dataset.color;
		this.headerMenu.style.background = event.target.dataset.color;
		this.underHeader.style.background = event.target.dataset.color;
		this.underFooter.style.background = event.target.dataset.color;

		const color = event.target.dataset.color === '#fff' ? '' : '#fff';
		this.headerMenu.style.color = color;
		this.headerMenuItems.forEach( ( el ) => ( el.style.color = color ) );

		this.brands.forEach( ( currentValue, currentIndex ) => {
			if ( currentIndex === index ) {
				currentValue.classList.add( 'active' );
			} else {
				currentValue.classList.remove( 'active' );
			}
		} );

		this.descriptions.forEach( ( currentValue, currentIndex ) => {
			if ( currentIndex === index ) {
				currentValue.classList.add( 'active' );
			} else {
				currentValue.classList.remove( 'active' );
			}
		} );

		const activeBrand = this.brands[ index ].dataset.name;

		this.footnotes.forEach( ( currentValue ) => {
			if ( currentValue.dataset.name === activeBrand ) {
				currentValue.classList.add( 'active' );
			} else {
				currentValue.classList.remove( 'active' );
			}
		} );

		const nextButton = document.querySelector(
			'.brand-description.active .swiper-button-next'
		);
		const prevButton = document.querySelector(
			'.brand-description.active .swiper-button-prev'
		);

		if (
			document.querySelectorAll(
				'.brand-description.active .swiper-slide'
			).length > 0
		) {
			const swiper = new Swiper(
				'.brand-description.active .swiper-container',
				{
					slidesPerView:
						window.innerWidth < 500
							? 1
							: window.innerWidth < 768
							? 3
							: 5,
					spaceBetween: 5,
					freeMode: true,
					preloadImages: false,
					lazy: {
						loadPrevNext: true,
					},
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev',
					},

					touchEventsTarget: 'wrapper',
				}
			);

			nextButton.addEventListener( 'click', () => swiper.slideNext() );
			prevButton.addEventListener( 'click', () => swiper.slidePrev() );
		}

		if (
			document.querySelectorAll(
				'.brand-description.active .swiper-slide'
			).length <= 5
		) {
			nextButton.style.display = 'none';
			prevButton.style.display = 'none';
		} else if ( window.innerWidth >= 1280 ) {
			nextButton.style.display = 'flex';
			prevButton.style.display = 'flex';
		}

		if ( window.innerWidth >= 768 ) {
			this.timeline.scrollIntoView();
		} else {
			const yOffset = -50;
			const element = document.querySelector(
				'.brand-description.active'
			);
			const y =
				element.getBoundingClientRect().top +
				window.pageYOffset +
				yOffset;

			window.scrollTo( { top: y, behavior: 'smooth' } );
		}
	}
}
